function kos_smazZasilkovnu() {
  var $cenaSmazani = get(window.ruzne, "zasilkovna.cenaSmazani") || false;

  if (
    typeof $cenaSmazani == "undefined" ||
    typeof $cenaSmazani != "number" ||
    !$cenaSmazani
  )
    return false;

  var $zasilkovna = $("#shipping-21");
  if (!$zasilkovna.length) return false;

  var $suma = kos_vratSumu();

  /*
    var $c=dataLayer[0].shoptet.cart;
    if(typeof $c=='undefined' || typeof $c!='object' || !$c.length )return false;

    var $suma=0;
    $c.forEach(function(entry) {
        $suma+= entry.quantity * entry.priceWithVat;

    });
    */

  if ($suma && $suma >= $cenaSmazani) $zasilkovna.remove();
} //function  kos_smazZasilkovnu()

function kos_zobrazHlaskuKaranteny($div, $message) {
  $div.find(".dvHlaskaRozvoz").remove();

  $('<div class="dvHlaskaRozvoz">' + $message + "</div>").appendTo($div);
} //function  kos_zobrazHlaskuKaranteny()

function kos_hlaskaKaranteny() {
  var $zobrazit = get(window, "karantena.zobrazit") || false;
  if (!$zobrazit) return false;

  var $c = window.karantena;

  document.addEventListener(
    "shoptet.checkout.callShippingBillingRelations",
    function() {
      var $div = $($c.idDivDopravce);

      if ($div.hasClass("active")) {
        kos_zobrazHlaskuKaranteny($div, $c.hlaska);
      }
    }
  );
} //function  kos_hlaskaKaranteny()

function kosik_zobrazFormProSlevuZtp() {
  if ($(".discount-coupon .applied-coupon").length) return false;

  var $kupon = get(window.ruzne, "sleva.ztp.kod") || false;
  if (!$kupon) return false;

  var $minPrice = get(window.ruzne, "sleva.ztp.minPrice") || false;
  if (!$minPrice) return false;

  var $suma = kos_vratSumu();
  if ($suma && $suma < $minPrice) return false;

  var $cena = get(window.ruzne, "sleva.ztp.cena") || false;
  if (!$cena) return false;

  var $kod =
    '<div id="dvZtp"> \
        <div class="flx"> \
            <div class="leva">   \
                PRO DRŽITELE PRŮKAZU ZTP \
                <strong><em>' +
    $cena +
    ' SLEVA</em> NA NÁKUP</strong> \
            </div><!-- class="leva"--> \
            <div class="prava"> \
               <a href="" data-kod="' +
    $kupon +
    '">UPLATNIT SLEVU</a>  \
            </div><!-- class="prava"--> \
        </div><!-- class="flx"--> \
        <p>Při převzetí balíku je nutné se prokázat platným průkazem <strong>ZTP</strong> nebo <strong>ZTP/P</strong></p> \
    </div><!--id="dvZtp" -->';

  $($kod).insertAfter("#cart-wrapper .cart-summary h4");

  $("#dvZtp a").click(function(e) {
    e.preventDefault();
    var $input = $("#discountCouponCode");

    //---odeslani slevoveho kuponu

    $input.val($(this).data("kod"));
    $input.closest("form").submit();
  });
} //function  kosik_zobrazFormProSlevuZtp()

export function kosik_vypisKosiku() {
  kosik_zobrazFormProSlevuZtp();

  document.addEventListener("ShoptetDOMCartContentLoaded", function() {
    kosik_zobrazFormProSlevuZtp();
  });
} //function  kosik_vypisKosiku()

export function kosik_krok1() {
  kos_smazZasilkovnu();
  kos_hlaskaKaranteny();
} //function  kosik_krok1()

export function kos_vratSumu() {
  var $c = fce.get(window.dataLayer[0], "shoptet.cart") || false;

  if (!$c || !$c.length) return false;
  var $suma = 0;
  $c.forEach(function(entry) {
    $suma += entry.quantity * entry.priceWithVat;
  });

  return $suma;
}
